<template>
  <div id="HistoricNfe">
    <v-dialog v-model="open" persistent max-width="700">
      <v-card class="align-center">
        <v-card-text>
          <div class="pt-5 pb-1 d-flex align-center justify-space-between">
            <h1>Histórico</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="mt30"></div>
          <div>
            <v-timeline dense>
              <v-timeline-item
                v-for="(history, historyIndex) in historic"
                :key="historyIndex"
                :color="history.color"
                :icon="history.icon"
              >
                <v-card class="elevation-2">
                  <v-card-title class="pb-0">
                    <v-row>
                      <v-col cols="12" md="7">
                        <h6>
                          {{ transformDateTime(history.createdAt) }}
                        </h6>
                      </v-col>
                      <v-col cols="12" md="5" style="text-align: end">
                        <HistoryStatus :status="history.status" />
                      </v-col>
                    </v-row>
                  </v-card-title>

                  <v-card-text class="d-flex flex-column">
                    <span
                      ><strong style="font-weight: 600">Tipo de usuário:</strong>
                      {{ `${history.userRoles[0].name}` }}</span
                    >
                    <span><strong style="font-weight: 600">Nome do usuário: </strong> {{ history.userName }}</span>
                    <span>
                      <strong style="font-weight: 600">Justificativa: </strong>
                      {{ history.justification ? history.justification : '-' }}
                    </span>
                    <span>
                      <strong style="font-weight: 600">Número do chamado: </strong>
                      {{ history.quarantineCallNumber ? history.quarantineCallNumber : '-' }}
                    </span>
                    <span>
                      <strong style="font-weight: 600">Observação: </strong>
                      {{ history.obs ? history.obs : '-' }}
                    </span>
                    <div v-if="history.justificationAttachments.length > 0">
                      <div v-if="!loadingImages">
                        <HistoryImages :images="history.images" />
                      </div>
                      <v-row class="d-flex align-center flex-column py-4" v-else>
                        <span class="pb-2">Carregando Imagens...</span>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </div>
          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="info" class="flex-grow-1" large @click="close()"> VOLTAR </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import maskDateTime from '../../utils/maskDateTime';
import HistoryImages from './HistoryImages.vue';

import HistoryStatus from './HistoryStatus.vue';

export default {
  name: 'HistoricNfe',
  props: {
    open: {
      default: false,
      type: Boolean
    },
    id: {
      default: null,
      type: [Number, String]
    }
  },
  components: {
    HistoryImages,
    HistoryStatus
  },
  data: () => ({
    historic: [],
    loadingImages: false
  }),
  watch: {
    async open(val) {
      if (val === true) {
        this.historic = [];
        await this.fetchAllHistorics();
        this.fetchAllImages();
      }
    }
  },
  computed: {
    ...mapGetters('NfeStore', ['getHistorics'])
  },
  methods: {
    ...mapActions('NfeStore', ['fetchHistoric', 'getJustificationsAttachmentsImage']),
    async fetchAllHistorics() {
      this.loading = true;
      try {
        const newHistoric = await this.fetchHistoric(this.id);
        this.historic = newHistoric.map((item) => {
          return {
            ...item,
            images: [],
            color: this.getColor(item.status),
            icon: this.getIcon(item.status)
          };
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchAllImages() {
      this.historic.map((history) => {
        if (history.justificationAttachments.length > 0) {
          this.loadingImages = true;
          Promise.all(
            history.justificationAttachments.map(async (attachment) => {
              return await this.getJustificationsAttachmentsImage(attachment.id);
            })
          ).then((images) => {
            history.justificationAttachments.map((attachment, index) => {
              history.images.push({ id: attachment.id, src: images[index] });
            });
            this.loadingImages = false;
          });
        }
      });
    },
    close() {
      this.$emit('closeHistoricNfe');
    },
    transformDateTime(date) {
      return maskDateTime(date);
    },
    getColor(sticksName) {
      switch (sticksName) {
        case 'Pendente':
          return 'warning';
        case 'Entrega Direta':
          return 'primary';
        case 'Aceito Pelo Transbordo':
          return 'primary';
        case 'Alocado para Entregador':
          return 'primary';
        case 'Quarentena de Transferência':
          return 'warning';
        case 'Entregue Com Sucesso':
          return 'green';
        case 'Entregue com Pendência':
          return 'warning';
        case 'Extraviado':
          return 'error';
        case 'A Devolver':
          return 'warning';
        case 'Devolvido Com Sucesso':
          return 'deep-purple darken-1';
        case 'Devolvido Com Pendência':
          return 'error';
        case 'Devolvido para Reentrega':
          return 'error';
        case 'Em transferência':
          return 'primary';
        case 'Quarentena de Entrega':
          return 'warning';
        case 'Tentar entregar novamente':
          return 'warning';
        case 'Devolvido Pelo Transbordo':
          return 'warning';
        default:
          return 'primary';
      }
    },
    getIcon(sticksName) {
      switch (sticksName) {
        case 'Pendente':
          return 'mdi-alert';
        case 'Entrega Direta':
          return 'mdi-truck';
        case 'Aceito Pelo Transbordo':
          return 'mdi-truck';
        case 'Alocado para Entregador':
          return 'mdi-run';
        case 'Quarentena de Transferência':
          return 'mdi-alert';
        case 'Entregue Com Sucesso':
          return 'mdi-check';
        case 'Entregue com Pendência':
          return 'mdi-close';
        case 'Extraviado':
          return 'mdi-close';
        case 'A Devolver':
          return 'mdi-alert';
        case 'Devolvido Com Sucesso':
          return 'mdi-check';
        case 'Devolvido Com Pendência':
          return 'mdi-close';
        case 'Devolvido para Reentrega':
          return 'mdi-close';
        case 'Em transferência':
          return 'mdi-truck';
        case 'Quarentena de Entrega':
          return 'mdi-alert';
        case 'Tentar entregar novamente':
          return 'mdi-alert';
        case 'Devolvido Pelo Transbordo':
          return 'mdi-alert';
        default:
          return 'mdi-clock-outline';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#HistoricNfe {
}
</style>
